var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{staticClass:"component-vehicle-confirm-image text-xs-center",attrs:{"column":""}},[_c('Img',{staticClass:"ma-auto",attrs:{"src":_vm.confirmImage,"contain":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }